export default __webpack_public_path__ + "85a18f0828c2b43b7075e155f7658679.svg";